import { CloudIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { CreateManualScrapePostResponse } from "../api/Items";
import { Modal } from "../shared-components/Modal";

type Props = { storedPosts: CreateManualScrapePostResponse[] | undefined };

export const ManualScrapeCreatedPostsModal = ({ storedPosts }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  function close() {
    setIsOpen(false);
  }
  function show() {
    setIsOpen(true);
  }
  return (
    <div>
      {storedPosts && (
        <div
          className="flex gap-1 ml-2 px-2 py-1 text-gray-50 bg-green-600 rounded-xl cursor-pointer"
          onClick={show}
        >
          <CloudIcon className="w-6" />
          {storedPosts.length.toString()}
        </div>
      )}
      <Modal open={isOpen} onClose={close} title={""} width={"w-5/6"}>
        <div>
          <h2 className="text-xl pb-3">
            Number of Saved Posts: {storedPosts?.length.toString()}
          </h2>
          {storedPosts?.map((post) => (
            <div key={post.external_id} className="w-full pb-3 overflow-auto">
              <div className="w-full flex items-center">
                <div className="truncate">{post.content?.text}</div>
              </div>
              <div className="w-full flex items-center">
                <span className="w-1/2 truncate">
                  <a
                    href={post.content.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs text-blue-500 decoration-transparent"
                  >
                    {post.content.url}
                  </a>
                </span>
              </div>
              {post.content?.media && (
                <span className="text-sm">
                  Media: {post.content?.media?.length}
                </span>
              )}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};
